import "./styles.css";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import { GeoLocationIcon } from "../icons/GeoLocationIcon";

export const GeoBlockPage = ({ onResetClick }) => {
  const { t } = useTranslation("geoBlockPage");

  return (
    <div className="geo-block-page">
      <div className="geo-block-text-wrapper">
        <GeoLocationIcon className="geo-block-icon" />
        <h4 className="geo-block-title">{t("geo-block-title")}</h4>
        <p className="geo-block-info">{t("geo-block-info")}</p>
      </div>
      <div className="geo-block-reset-button">
        <Button text={t("reset")} onClick={() => onResetClick()} />
      </div>
    </div>
  );
};
